import { render, staticRenderFns } from "./category-service-select-new2.vue?vue&type=template&id=9a82ab70"
import script from "./category-service-select-new2.vue?vue&type=script&lang=js"
export * from "./category-service-select-new2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports